import React, { useEffect, useState } from "react";
import Button from "../atom/Button";
import Modal from "../modecules/Modal";
import Exclamation from "../../assets/images/exclamation.png";
import UserBoardService from "../../service/UserBoardService";
import styled from "styled-components";
import ModalLookup from "../modecules/ModalLookup";
import TitleHeader from "../modecules/TitleHeader";
import TextInput from "../atom/TextInput";
import TextArea from "../atom/TextArea";
import FielUpload from "../atom/FileUpload";
// import ReCAPTCHA from "react-google-recaptcha";
// import Captcha from "../atom/Capcha";

interface IData {
  title: string;
  content: string;
  name: string;
  fileName: string | null;
  password: string;
  phoneNumber: string;
  serviceSortation: string;
  email: string;
}

function UserVocWritePage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [lookUp, setLookup] = useState(false);
  const [uploadFile, setUploadFile] = useState<any>(null);
  const [writer, setWriter] = useState("");
  const [phoneNum, setPhoneNum] = useState<undefined | string>();
  const [title, setTitle] = useState<undefined | string>();
  const [text, setText] = useState<undefined | string>();
  const [pwd, setPwd] = useState<undefined | string>();
  const [data, setData] = useState<IData>({
    title: "",
    content: "",
    name: "",
    fileName: null,
    password: "",
    phoneNumber: "",
    serviceSortation: "",
    email: "",
  });
  const [vocNum, setVocNum] = useState();
  const [formData, setFormData] = useState();
  const [Email, setEmail] = useState<undefined | string>();
  //   const [serviceSortation, setServiceSortation] = useState<string>();
  //   const [serviceName, setServiceName] = useState<string>();
  const [checkCapcha, setCheckCapcha] = useState(false);

  // const date1 = new Date("2023-02-13 15:41:00");
  // console.log(Date.now() - date1.getTime());

  const lookUpModal = () => {
    setModalOpen(true);
  };
  //사이트 진입시 출처 확인
  const originUrlKeyValues = window.location.search;
  const urlParams = new URLSearchParams(originUrlKeyValues);
  const originStie = urlParams.get("origin");
  const originStieCode = urlParams.get("code");
  // console.log(originStieCode);

  //출처가 없을 시
  useEffect(() => {
    if (!originStie || !originStieCode) {
      //기타 코드
      //   setServiceName("기타");
      //   setServiceSortation("06");
      sessionStorage.setItem("origin", "기타");
      sessionStorage.setItem("code", "06");
    }
  }, [originStie, originStieCode]);

  //출처가 있을 시 바뀔 때
  useEffect(() => {
    if (!!originStie && originStie !== null && !!originStieCode && originStieCode !== null) {
      sessionStorage.setItem("origin", `${originStie}`);
      sessionStorage.setItem("code", `${originStieCode}`);
    }
  }, [originStie, originStieCode]);

  //서버로 문의글 전송
  const sendDataToServer = async () => {
    if (!writer || !phoneNum || !pwd || !title || !text || !Email) {
      alert("작성되지 않은 항목이 있습니다 내용을 다시 한번 확인해주세요");
      return;
    }

    lookUpModal();

    const response = await UserBoardService.writeVoc(data, uploadFile);
    if (response.status === "success") {
      setVocNum(response.data.no);
      setFormData(response.data);
    } else {
      alert("문의글 작성이 실패하였습니다. 관리자에게 문의해주세요");
    }
  };
  //캡챠 기능
  // useEffect(() => {
  //   const checkOkCapcha = async () => {
  //     const response = await UserBoardService.writeVoc(data, uploadFile);
  //     if (response.status === "success") {
  //       setVocNum(response.data.no);
  //       setFormData(response.data);
  //     } else {
  //       alert("문의글 작성이 실패하였습니다. 관리자에게 문의해주세요");
  //     }
  //   };
  //   if (checkCapcha === true) {
  //     checkOkCapcha();
  //   }
  // }, [checkCapcha]);

  const openLookup = () => {
    setLookup(true);
  };
  const closeLookup = () => {
    setLookup(false);
  };

  //폼데이터
  const changeWriter = (e: React.ChangeEvent<HTMLInputElement>) => {
    setWriter(e.target.value);
  };
  const changePhoneNum = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhoneNum(e.target.value);
  };
  const changeTitle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };
  const changeText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
  };
  const changePwd = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPwd(e.target.value);
  };
  const changeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };
  // 파일 업로드 코드 중복
  // const handleChangeFile = (event: React.ChangeEvent<HTMLInputElement>): void => {
  //   const file = event.target.files?.[0];
  //   if (file) {
  //     setUploadFile(file);
  //   } else {
  //     setUploadFile(null);
  //   }
  //   //파일사이즈
  //   const fileSize: number | undefined = event.target.files?.[0]?.size;
  //   //최대 파일사이즈
  //   const maxSize = 20000000;
  //   if (fileSize && fileSize > maxSize) {
  //     alert(`20MB 이내의 파일만 첨부 가능합니다.\n현재 파일크기_${(fileSize / (1000 * 1000)).toFixed(1)}MB`);
  //     setUploadFile(null);
  //   } else if (fileSize && fileSize < maxSize) {
  //     setUploadFile(fileSize);
  //   }
  // };
  useEffect(() => {
    if (uploadFile instanceof Blob || "null") {
      setData({
        title: title!,
        content: text!,
        name: writer,
        fileName: uploadFile?.name || null,
        password: pwd!,
        phoneNumber: phoneNum!,
        serviceSortation: originStieCode!,
        email: Email!,
      });
    }
  }, [writer, phoneNum, title, text, pwd, uploadFile, originStieCode, Email]);

  return (
    <>
      {
        <PageBox>
          <TitleHeader title={"VOC 접수"} subTitle={"문의하실 내용을 작성해주세요."} />

          <Box1>
            <TextInput
              boxWidth={30}
              labelWidth={30}
              inputWidth={70}
              onChange={changeWriter}
              htmlFor="VocWriteName"
              labelName="작성자"
              name="inputName"
              type="text"
              placeholder="이름"
              required
              maxLength={10}
            />
            <TextInput
              boxWidth={30}
              labelWidth={30}
              inputWidth={70}
              onChange={changePhoneNum}
              htmlFor="VocWritePhone"
              labelName="연락처"
              onInput={(e: any) => {
                if (e.target.value.length > e.target.maxLength)
                  e.target.value = e.target.value.slice(0, e.target.maxLength);
              }}
              name="inputName"
              type="number"
              placeholder="'-'을 제외한 숫자"
              maxLength={11}
              appearance={"none"}
            />
            <TextInput
              boxWidth={30}
              labelWidth={30}
              inputWidth={70}
              onChange={changePwd}
              labelName="패스워드"
              name="inputName"
              type="password"
              placeholder="6자리 미만"
              maxLength={6}
            />
          </Box1>
          <Box2>
            <TextInput
              boxWidth={100}
              labelWidth={9}
              inputWidth={91}
              onChange={changeTitle}
              htmlFor="VocTitle"
              labelName="제목"
              name="VocTitle"
              type="text"
              placeholder="제목을 입력해주세요"
              required
              maxLength={30}
            />
            <TextArea
              boxWidth={100}
              labelWidth={9}
              inputWidth={91}
              inputHeight={300}
              htmlFor="VocInfo"
              labelName="내용"
              onChange={changeText}
              name="VocInfo"
              placeholder="문의내용을 800자 이내로 상세하게 작성해주세요"
              isRequired={true}
              maxLength={1000}
            />
            <TextInput
              boxWidth={100}
              labelWidth={9}
              inputWidth={91}
              onChange={changeEmail}
              labelName="이메일"
              name="inputName"
              type="email"
              placeholder="답변받으실 이메일을 입력해주세요"
            />
          </Box2>
          <Box3>
            <FielUpload
              labelWidth={16}
              inputWidth={80}
              // handleChangeFile={handleChangeFile}
              setUploadFile={setUploadFile}
              uploadFile={uploadFile}
            />
            <ServiceOriginWrapper>
              <label>서비스 구분</label>
              <div>{!!originStie && originStie !== null ? <p>{originStie}</p> : <p>미분류</p>}</div>
            </ServiceOriginWrapper>
          </Box3>
          <Line></Line>
          <Box4>
            <Button
              text={"VOC 조회"}
              backgroundColor={"#388fc0"}
              fontColor={"white"}
              borderRadius={"5px"}
              width={"127px"}
              onClick={openLookup}
              type={"submit"}
            />
            <Button
              type={"submit"}
              text={"등록"}
              backgroundColor={"#388fc0"}
              fontColor={"white"}
              borderRadius={"5px"}
              onClick={() => {
                sendDataToServer();
              }}
            />
          </Box4>
          <ModalBox>
            <ModalLookup text={"VOC 조회"} open={lookUp} close={closeLookup} />
          </ModalBox>
          <ModalBox2>
            <Modal open={modalOpen} formData={formData} checkCapcha={checkCapcha} setCheckCapcha={setCheckCapcha}>
              <div className="modalStyle">
                <img src={Exclamation} alt="Exclamation Icon" />
                <p>등록되었습니다.</p>
              </div>
              <div className="listNum">
                <p>게시글 번호 : {vocNum}</p>
                <p>*게시글 번호는 VOC 내역 조회 시 사용됩니다.</p>
              </div>
            </Modal>
          </ModalBox2>
        </PageBox>
      }
    </>
  );
}

//css
const PageBox = styled.div`
  margin-top: 80px;
  display: flex;
  width: 60%;
  /* left: 20%; */
  /* position: fixed; */
  flex-direction: column;
  align-items: center;
  @media ${(props) => props.theme.device.laptop} {
    margin-top: 40px;
    width: 80%;
  }
`;

const Box1 = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 60px;
  @media ${(props) => props.theme.device.laptop} {
    margin-top: 30px;
    flex-direction: column;
  }
`;
const Box2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 12px;
`;
const Box3 = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  @media ${(props) => props.theme.device.laptop} {
    flex-direction: column;
  }
`;

const ServiceOriginWrapper = styled.div`
  display: flex;
  width: 18%;
  justify-content: right;
  align-items: center;
  font-size: 12px;
  > div > p {
    margin-left: 8px;
  }
  @media ${(props) => props.theme.device.laptop} {
    margin-top: 20px;
    width: 100%;
  }
`;
const Line = styled.div`
  width: 100%;
  margin-top: 32px;
  border-top: solid 1px #ccc;
`;
const Box4 = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const ModalBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
const ModalBox2 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export default UserVocWritePage;
